import React from 'react';
import halalKibbeh from 'src/assets/img/category-pages/halal/halal-kibbeh.svg';
import halalLambTagine from 'src/assets/img/category-pages/halal/halal-lamb-tagine.svg';
import halalOuzieWithLegOfLamb from 'src/assets/img/category-pages/halal/halal-ouzi-with-leg-of-lamb.svg';
import { HalalComplianceModal } from 'src/pages/consumer/dish-first/explore/components/PageHero/VerifiedDietaryPageHero/HalalCompliance/HalalComplianceModal';
import { DietaryHalal } from 'src/shared/design-system/Icon';
import { useModal } from 'src/shared/hooks/useModal';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

const ComplianceBanner = styled.div`
  width: 100%;
  background: ${Colors.JACKFRUIT_LITE_30};
`;

const ComplianceContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${Spacing.DOUBLE} ${Spacing.SINGLE};
  gap: ${Spacing.SINGLE_QUARTER};

  width: 100%;

  @media (min-width: ${ScreenWidth.MEDIUM}) {
    width: 800px;
  }
  @media (min-width: ${ScreenWidth.LARGE}) {
    width: 1066px;
  }

  margin-right: auto;
  margin-left: auto;
`;
const ComplianceTitle = styled.h4`
  font-weight: ${Font.Weight.BOLD};
  font-size: ${Font.Size.M};
  line-height: 120%;
  color: ${Colors.GRAY_DARK_30};
`;
const ComplianceSubTitle = styled.span`
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XS};
  line-height: 120%;
  color: ${Colors.GRAY_DARK_15};
`;
const ComplianceCta = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XS};
  line-height: 120%;
  color: ${Colors.GRAY_DARK_30};
  cursor: pointer;
`;

const MediumScreenImage = styled.img`
  display: none;

  ${minScreen(ScreenWidth.SMALL)} {
    display: flex;
  }
`;

const LargeScreenImage = styled.img`
  display: none;

  ${minScreen(ScreenWidth.LARGE)} {
    display: flex;
  }
`;

type IProps = {
  className?: string;
};

export const HalalComplianceBanner: React.FC<IProps> = ({ className }) => {
  const { isShowing, show, hide } = useModal();

  return (
    <>
      <ComplianceBanner className={className} onClick={show}>
        <ComplianceContent>
          <div className='flex grow flex-col'>
            <div className='mb-2 flex flex-row justify-start'>
              <DietaryHalal className='-mt-1 mr-2' width={24} height={24} />
              <ComplianceTitle>Serving our Halal community</ComplianceTitle>
            </div>
            <ComplianceSubTitle className='mb-2'>
              Respecting Halal's diverse interpretations, we foster transparency regarding food preparation and
              ingredients.
            </ComplianceSubTitle>
            <ComplianceCta>
              <span>Read More</span>
              <i className='fa fa-chevron-right ml-1 mt-px text-xxs' />
            </ComplianceCta>
          </div>

          <img src={halalOuzieWithLegOfLamb} width={104} height={104} alt='Image of halal ouzi with leg of lamb' />
          <MediumScreenImage src={halalLambTagine} width={104} height={104} alt='Image of halal lamb tagine' />
          <LargeScreenImage src={halalKibbeh} width={104} height={104} alt='Image of halal kibbeh' />
        </ComplianceContent>
      </ComplianceBanner>
      {isShowing ? <HalalComplianceModal isShowing={isShowing} onClose={hide} /> : null}
    </>
  );
};
